<script setup lang="ts">
import { onMounted } from "vue";
import { useGtag } from "vue-gtag-next";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ProductVersion } from "@/apps/merchant3/types/ProductVersion";
import { SessionStorageEnum } from "@/apps/merchant3/enums/sessionStorageEnum";
const { pageview, set } = useGtag();
const route = useRoute();
const store = useStore();
onMounted(() => {
  // Retrieve MktGid from sessionStorage
  if (store.state?.carts?.productVersion === ProductVersion.M3_ECOMMERCE) {
    const mktGid = sessionStorage.getItem(SessionStorageEnum.MktGid);
    if (mktGid && mktGid !== "") {
      // Pass MktGid to Google Analytics
      try {
        set({ user_id: mktGid });
        pageview({
          page_title: route.name,
          page_path: route.fullPath,
          page_location: window.location.href,
        });
        // eslint-disable-next-line no-empty
      } catch (error) {}
    }
  }
});
</script>
<template>
  <div class="d-none"></div>
</template>
<style scoped lang="scss"></style>
